import { useNavigate } from 'react-router-dom'
import { Button } from '@orientamos/ui'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      {/* 404 Illustration */}
      <div className="mb-8">
        <svg
          className="w-48 h-48 text-neutral-300"
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Document with question mark */}
          <rect
            x="50"
            y="30"
            width="100"
            height="130"
            rx="8"
            fill="currentColor"
            fillOpacity="0.3"
          />
          <rect x="60" y="50" width="60" height="6" rx="3" fill="currentColor" fillOpacity="0.5" />
          <rect x="60" y="65" width="80" height="6" rx="3" fill="currentColor" fillOpacity="0.5" />
          <rect x="60" y="80" width="50" height="6" rx="3" fill="currentColor" fillOpacity="0.5" />
          {/* Question mark */}
          <text
            x="100"
            y="140"
            textAnchor="middle"
            fontSize="48"
            fontWeight="bold"
            fill="currentColor"
            fillOpacity="0.6"
          >
            ?
          </text>
          {/* Magnifying glass */}
          <circle
            cx="145"
            cy="125"
            r="25"
            stroke="currentColor"
            strokeWidth="6"
            fill="none"
            strokeOpacity="0.4"
          />
          <line
            x1="163"
            y1="143"
            x2="180"
            y2="160"
            stroke="currentColor"
            strokeWidth="6"
            strokeLinecap="round"
            strokeOpacity="0.4"
          />
        </svg>
      </div>

      {/* Error code */}
      <h1 className="text-6xl font-bold text-neutral-200 mb-4">404</h1>

      {/* Title */}
      <h2 className="text-2xl font-semibold text-neutral-900 mb-2">Pagina no encontrada</h2>

      {/* Description */}
      <p className="text-neutral-500 mb-8 max-w-md">
        Lo sentimos, la pagina que buscas no existe o ha sido movida. Verifica la URL o regresa al
        inicio.
      </p>

      {/* Actions */}
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver
        </Button>
        <Button onClick={() => navigate('/')}>
          <Home className="w-4 h-4 mr-2" />
          Ir al Inicio
        </Button>
      </div>
    </div>
  )
}
